import { Store } from '@jwplayer/fe-common/module/store/react';

import type { createPoller } from '/module/poller';

export type PollerType = 'tags' | 'media';

export const PollerStore = new Store<{
  items: Record<PollerType, Record<string, ReturnType<typeof createPoller>>>;
}>({
  items: { tags: {}, media: {} },
});
